module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-bread-cumb', {
    attrs: {
      "bread-cumb": _vm.breadCumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "warp50"
  }, [_c('el-form', {
    ref: "userForm",
    attrs: {
      "model": _vm.userForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户组:",
      "prop": "group_ids"
    }
  }, _vm._l((_vm.groups), function(group) {
    return _c('div', [_c('p', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(group.category_name))]), _vm._v(" "), _c('el-checkbox-group', {
      model: {
        value: (_vm.userForm.group_ids),
        callback: function($$v) {
          _vm.$set(_vm.userForm, "group_ids", $$v)
        },
        expression: "userForm.group_ids"
      }
    }, _vm._l((group.group), function(item) {
      return _c('el-checkbox', {
        key: item.group_id,
        attrs: {
          "label": item.group_id,
          "checked": item.checked
        }
      }, [_vm._v(_vm._s(item.title))])
    }), 1)], 1)
  }), 0), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('userForm')
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('userForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64f9a1be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/system/user/relatedGroup.vue
// module id = 918
// module chunks = 0